/* =============================================================================
 * [OS-LEGADO-CONGELADO] ARQUIVO TEMPORARIO - APAGAR APOS VALIDACAO
 * =============================================================================
 * Copia CONGELADA do modulo antigo de "OS para coleta" (versao que estava em
 * producao antes da entrada do modulo novo).
 *
 * Origem desta copia: src/Components/ButtonCustom/styled.ts
 * Papel: componente compartilhado congelado
 *
 * POR QUE ISSO EXISTE
 *   O modulo novo de OS substituiu o antigo. Esta copia fica disponivel por
 *   ~1 SEMANA como plano de contingencia: se o modulo novo apresentar
 *   problema, o time volta a usar esta versao sem interromper o trabalho.
 *
 * NAO EDITE ESTE ARQUIVO
 *   Ele e um retrato fiel do comportamento antigo. Qualquer correcao deve ser
 *   feita no modulo NOVO. Editar aqui destroi o valor da copia.
 *
 * COMO APAGAR (quando o modulo novo for validado)
 *   1. Remover a pasta inteira: src/Views/app/precisao/OSAntigaLegado/
 *   2. Remover a rota/menu marcado com [OS-LEGADO-CONGELADO] em
 *      src/Configs/Navegacao.ts
 *   3. Conferir que nao sobrou nenhuma referencia:
 *        grep -rn "OSAntigaLegado\|OS-LEGADO-CONGELADO" src/
 *   Nada fora desta pasta depende dela, entao a remocao e segura.
 * ========================================================================== */

import styled from "styled-components";


export const Button = styled.button`    
    font-size: 14px;
    height: 32px;
    padding: 4px 12px;
    border-radius: 6px;
    border: none;
    background: var(--primary-color);
    color: #fff;
    display: inline-flex;
    gap: 7px;
    align-items: center;
    cursor: pointer;
    font-weight: 500;
    transition: .3s;
    will-change: transform;
    white-space: nowrap;
    position: relative;

    &&:not([data-type = 'secondary']):hover {
        filter: brightness(115%);
    }

    &&:active {
        transform: scale(0.98);
    }

    :hover:is([data-type = 'primary']) {
        filter: brightness(110%);
    }

    &&:disabled {
        background-color: var(--disabled-color) !important;
        color: var(--disabled-text-color) !important;
        border-color: var(--disabled-text-color);
        cursor: not-allowed;
    }
    :is([data-danger = true]) {
        background-color: var(--danger-color);
        color: #fff;
    }

    &&:is([data-type = 'secondary']) {
        background-color: transparent;
        color: var(--primary-color);
        border: thin solid var(--primary-color);
    }
    &&:is([data-type = 'secondary']):hover {
        background-color: var(--primary-color);
        color: #fff;
    }
    &&:is([data-type = 'secondary']):is([data-danger = true]) {
        background-color: transparent;
        color: var(--danger-color);
        border: thin solid var(--danger-color);
    }
    &&:is([data-type = 'secondary']):is([data-danger = true]):hover {
        background-color: var(--danger-color);
        color: #fff;
    }
    &&:disabled:is([data-type = 'secondary']) {
        background-color: var(--disabled-color) !important;
        color: var(--disabled-text-color) !important;
        /* border-color: var(--disabled-text-color); */
        border: none;
        cursor: not-allowed;
    }

    &&:is([data-type = 'tertiary']) {
        background-color: transparent;
        color: var(--primary-color);
        text-decoration: underline;
    }
    &&:is([data-type = 'tertiary']):hover {
        background-color: var(--primary-color);
        color: #fff;
    }

    &&:is([data-type = 'tertiary']):is([data-danger = true]) {
        background-color: transparent;
        color: var(--danger-color);
        text-decoration: underline;
    }
    &&:is([data-type = 'tertiary']):is([data-danger = true]):hover {
        background-color: var(--danger-color);
        color: #fff;
    }

    :is([data-notready = true]) {
        opacity: 0.7;
        cursor: help;
    }
`